"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _utils = require("../../../utils");
var _components = require("../../../components");
var _ = require("../..");
require("./SessionParticipationModal.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Title = _typography.default.Title,
  Paragraph = _typography.default.Paragraph;
var SessionParticipationModal = function SessionParticipationModal(_ref) {
  var onClose = _ref.onClose,
    session = _ref.session,
    showEmailModal = _ref.showEmailModal,
    toggleEmailModal = _ref.toggleEmailModal;
  var url = session ? (0, _utils.getGroupSessionParticipationUrl)(session.id) : null;
  var _useFetch = (0, _utils.useFetch)(url, [], !!session),
    participations = _useFetch.data,
    loading = _useFetch.loading;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _partition = (0, _lodash.partition)(participations, function (participation) {
      return (0, _utils.isPatient)(participation.account);
    }),
    _partition2 = _slicedToArray(_partition, 2),
    patientsParticipation = _partition2[0],
    cliniciansParticipation = _partition2[1];
  var sharedColumns = [{
    title: 'Attended',
    dataIndex: 'attendance',
    align: 'center',
    className: 'icon-column',
    render: function render(attendance) {
      return (0, _.isAttendanceAvailable)(session) ? attendance ? (0, _.renderAttendanceDuration)(attendance) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "close-square",
        className: "icon-default"
      }) : 'N/A';
    }
  }, {
    title: 'Joined',
    dataIndex: 'attendance',
    align: 'center',
    className: 'icon-column',
    render: function render(attendance) {
      if (!(0, _.isAttendanceAvailable)(session) || !attendance) {
        return 'N/A';
      }
      var momentJoinedAt = _momentTimezone.default.utc(attendance.createdAt);
      var joinTimeMinutesRelativeToStart = momentJoinedAt.diff(_momentTimezone.default.utc(session.startAt), 'minutes');
      var numMinutesRelativeToStart = Math.abs(joinTimeMinutesRelativeToStart);
      return joinTimeMinutesRelativeToStart < 0 ? "".concat(numMinutesRelativeToStart, " minutes early") : "".concat(numMinutesRelativeToStart, " minutes late");
    }
  }];
  var patientColumns = [{
    title: 'Patient',
    dataIndex: 'account',
    render: function render(account) {
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: "/patients/".concat(account.nickName, "/info")
      }, /*#__PURE__*/_react.default.createElement("div", null, (0, _utils.composeName)([account.firstName, account.lastName], ' ')), /*#__PURE__*/_react.default.createElement("div", null, account.email));
    }
  }, {
    title: 'RSVP',
    dataIndex: 'rsvp',
    align: 'center',
    className: 'icon-column',
    render: function render(rsvp) {
      return rsvp ? /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "check-square",
        theme: "filled",
        className: "icon-green"
      }) : /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "close-square",
        className: "icon-default"
      });
    }
  }];
  var clinicianColumns = [{
    title: 'Clinician',
    dataIndex: 'account',
    render: function render(account) {
      var descriptionPartial = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, (0, _utils.composeName)([account.firstName, account.lastName], ' ')), /*#__PURE__*/_react.default.createElement("div", null, account.email));
      return (0, _utils.isAdmin)(user) ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: "/clinicians/".concat(account.nickName)
      }, descriptionPartial) : descriptionPartial;
    }
  }];
  var rsvpCount = (0, _react.useMemo)(function () {
    return patientsParticipation.filter(function (_ref2) {
      var rsvp = _ref2.rsvp;
      return !!rsvp;
    }).length;
  }, [patientsParticipation]);
  var attendeeCount = (0, _react.useMemo)(function () {
    return participations.filter(function (_ref3) {
      var attendance = _ref3.attendance;
      return !!attendance;
    }).length;
  }, [participations]);
  var hasRecepients = rsvpCount > 0 || attendeeCount > 0;
  if (showEmailModal) {
    // TODO: this modal will be deprecated anyway?
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_modal.default, {
    className: "session-participation-modal",
    visible: !!session,
    onCancel: onClose,
    title: /*#__PURE__*/_react.default.createElement(Title, {
      level: 3
    }, "Session Participation"),
    footer: /*#__PURE__*/_react.default.createElement(_row.default, {
      type: "flex",
      justify: "end"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: onClose
    }, "OK"))
  }, session && !loading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Paragraph, null, (0, _.renderSessionTime)(session.startAt)), /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(Paragraph, {
    type: "secondary",
    justify: "left"
  }, rsvpCount, " rsvps /", ' ', (0, _.isAttendanceAvailable)(session) ? "".concat(attendeeCount, " attendees") : 'N/A attendees')), hasRecepients && /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    md: 12
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    justify: "end",
    onClick: toggleEmailModal
  }, "Send Email to RSVPs"))), /*#__PURE__*/_react.default.createElement(_components.DataTable, {
    columns: [].concat(patientColumns, sharedColumns),
    rowKey: function rowKey(_ref4) {
      var account = _ref4.account;
      return account.id;
    },
    dataSource: patientsParticipation,
    pagination: false
  }), /*#__PURE__*/_react.default.createElement(_components.DataTable, {
    columns: [].concat(clinicianColumns, sharedColumns),
    rowKey: function rowKey(_ref5) {
      var account = _ref5.account;
      return account.id;
    },
    dataSource: cliniciansParticipation,
    pagination: false
  })) : /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null));
};
var _default = SessionParticipationModal;
exports.default = _default;